// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__oeebr","resendInfoText":"OnGoingPaymentBox_resendInfoText__3Zqsr"};